import React from "react";

import { type Annotation } from "@features/custom-annotations";
import { formatDateTime } from "@north-beam/nb-common";

interface Props {
  annotation: Annotation;
}

const DISPLAY_FORMAT = "MMM D, YYYY";

const displayUser = (user?: Annotation["user"]) => {
  if (user?.first_name || user?.last_name) {
    return `, by ${user?.first_name ?? ""} ${user.last_name ?? ""}`;
  }
  return "";
};

export const AnnotationMetadata = ({
  annotation: { annotatedDate, endDate, updatedAt, user },
}: Props) => {
  const endDateText = endDate
    ? ` to ${formatDateTime(endDate, DISPLAY_FORMAT)}`
    : "";

  return (
    <div className="text-xxs flex justify-between text-interstellar+2">
      <span>
        {annotatedDate && formatDateTime(annotatedDate, DISPLAY_FORMAT)}
        {endDateText}
      </span>
      {updatedAt && (
        <span>
          Last update:{" "}
          {updatedAt && formatDateTime(updatedAt, `${DISPLAY_FORMAT} @h:mmA`)}
          {displayUser(user)}
        </span>
      )}
    </div>
  );
};
